import * as noUiSlider from 'nouislider';
export function createdNoUiSlider(slider, config) {
    if (slider) {
        noUiSlider.create(slider, {
            start: [config.startMin, config.startMax],
            step: config.step,
            connect: true,
            range: { min: config.min, max: config.max },
            handleAttributes: [
                { 'aria-label': config.labelMin },
                { 'aria-label': config.labelMax }
            ]
        });
    }
}
export function updateNoUiSlider(slider, config) {
    if (slider) {
        slider.noUiSlider.updateOptions({
            start: [config.startMin, config.startMax],
            step: config.step,
            connect: true,
            range: { min: config.min, max: config.max },
        });
    }
}
